module.exports = __webpack_public_path__ + "static/img/genomics_clusters_2.b8d6aa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/genomics_clusters_2.png
// module id = 6yPm
// module chunks = 6